
const initialState = {
    isLoggedIn: false,
    user: null,
    token: null,
    isLoading: false,
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_LOADING':
            return {
                ...state,
                isLoading: action.payload,
            };
        case "LOGIN":
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
                token: action.payload.token
            };
        case "LOGOUT":
            return {
                ...state,
                isLoggedIn: false,
                user: null,
                token: null
            };
        default:
            return state;
    }
};

export default authReducer;
